<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    item: CommonList;
    active: boolean;
    tabIndex?: number;
    name?: string;
    hideLabel?: boolean;
    disabled?: boolean;
    customContent?: Snippet<[{ active: boolean }]> | undefined;
    children?: Snippet | undefined;
    onchange?: (e: Event) => void;
  }

  let {
    item,
    active,
    tabIndex = 1,
    name = '',
    hideLabel = false,
    disabled = false,
    customContent = undefined,
    children = undefined,
    onchange
  }: Props = $props();
</script>

<div class="comp-radio">
  <div class="radio">
    <label for={`${item?.id}_${name}`}>
      <input
        type="radio"
        id={`${item?.id}_${name}`}
        {tabIndex}
        data-cy={item?.id}
        checked={active}
        {disabled}
        value={item.label}
        {onchange}
      />
      {#if !hideLabel}
        <div class="text">{item.label}</div>
      {/if}
      {@render children?.()}
    </label>
    {@render customContent?.({ active })}
  </div>
</div>

<style>
  .radio label {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }
  .radio label .text {
    margin-left: 8px;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
  }
</style>
